import { Guid, isNil, Nillable } from '@web/utils';
import { MultimediaType } from '../enums/multimedia-type';
import { isArchiveType, isDocumentType, isImageType } from '../api/helpers';

export class Multimedia {
  public constructor(
    private readonly data: {
      id: Guid;
      title: string;
      alt: string;
      url: string;
      extension: string;
      type?: Nillable<MultimediaType>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get title(): string {
    return this.data.title;
  }

  public get alt(): string {
    return this.data.alt;
  }

  public get url(): string {
    return this.data.url;
  }

  public get extension(): string {
    return this.data.extension;
  }

  public get type(): Nillable<MultimediaType> {
    return this.data.type;
  }

  public get isDocument(): boolean {
    if (isNil(this.type)) {
      return false;
    }

    return isDocumentType(this.type);
  }

  public get isArchive(): boolean {
    if (isNil(this.type)) {
      return false;
    }

    return isArchiveType(this.type);
  }

  public get isImage(): boolean {
    // Domyślnie traktuję jako obraz
    if (isNil(this.type)) {
      return true;
    }

    return isImageType(this.type);
  }
}
